import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiBookOpen } from 'react-icons/fi';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const checkoutUrl = "https://encouragingbv.gumroad.com/l/biblebookmark";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
        <div className="flex items-center gap-2 text-xl font-serif font-bold text-stone-800">
          <SafeIcon icon={FiBookOpen} className="text-amber-600" />
          <span>Bible Bookmark</span>
        </div>
        <div className="flex items-center gap-6">
          <div className="hidden sm:block text-right">
            <span className="block text-[10px] uppercase tracking-widest text-stone-400 font-bold mb-0.5">Limited Offer</span>
            <div className="flex items-center gap-2 leading-none">
              <span className="text-stone-400 line-through text-xs font-medium decoration-amber-500/50 decoration-2">$45.00</span>
              <span className="text-amber-700 font-bold text-lg">$2.99</span>
            </div>
          </div>
          <a 
            href={checkoutUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-amber-600 hover:bg-amber-700 text-white px-6 py-2.5 rounded-full font-bold transition-all shadow-sm hover:shadow-md active:scale-95 inline-block"
          >
            Get Yours Now
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;